/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { HeoCustomerOrderNumber } from './HeoCustomerOrderNumber';
import {
    HeoCustomerOrderNumberFromJSON,
    HeoCustomerOrderNumberFromJSONTyped,
    HeoCustomerOrderNumberToJSON,
    HeoCustomerOrderNumberToJSONTyped,
} from './HeoCustomerOrderNumber';

/**
 * 
 * @export
 * @interface CustomerOrderSummary
 */
export interface CustomerOrderSummary {
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderSummary
     */
    id: string;
    /**
     * 
     * @type {HeoCustomerOrderNumber}
     * @memberof CustomerOrderSummary
     */
    number: HeoCustomerOrderNumber;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderSummary
     */
    customerReference: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomerOrderSummary
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderSummary
     */
    total: number;
    /**
     * 
     * @type {OrderOrigin}
     * @memberof CustomerOrderSummary
     */
    orderOrigin?: OrderOrigin;
    /**
     * 
     * @type {OrderType}
     * @memberof CustomerOrderSummary
     */
    orderType?: OrderType;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerOrderSummary
     */
    productImageUrls: Array<string>;
    /**
     * 
     * @type {Address}
     * @memberof CustomerOrderSummary
     */
    shippingAddress?: Address;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderSummary
     */
    itemSalesAcceptedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderSummary
     */
    itemCustomerQuantity: number;
}



/**
 * Check if a given object implements the CustomerOrderSummary interface.
 */
export function instanceOfCustomerOrderSummary(value: object): value is CustomerOrderSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('customerReference' in value) || value['customerReference'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('productImageUrls' in value) || value['productImageUrls'] === undefined) return false;
    if (!('itemSalesAcceptedQuantity' in value) || value['itemSalesAcceptedQuantity'] === undefined) return false;
    if (!('itemCustomerQuantity' in value) || value['itemCustomerQuantity'] === undefined) return false;
    return true;
}

export function CustomerOrderSummaryFromJSON(json: any): CustomerOrderSummary {
    return CustomerOrderSummaryFromJSONTyped(json, false);
}

export function CustomerOrderSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerOrderSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': HeoCustomerOrderNumberFromJSON(json['number']),
        'customerReference': json['customerReference'],
        'createdAt': (new Date(json['createdAt'])),
        'total': json['total'],
        'orderOrigin': json['orderOrigin'] == null ? undefined : OrderOriginFromJSON(json['orderOrigin']),
        'orderType': json['orderType'] == null ? undefined : OrderTypeFromJSON(json['orderType']),
        'productImageUrls': json['productImageUrls'],
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
        'itemSalesAcceptedQuantity': json['itemSalesAcceptedQuantity'],
        'itemCustomerQuantity': json['itemCustomerQuantity'],
    };
}

export function CustomerOrderSummaryToJSON(json: any): CustomerOrderSummary {
    return CustomerOrderSummaryToJSONTyped(json, false);
}

export function CustomerOrderSummaryToJSONTyped(value?: CustomerOrderSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': HeoCustomerOrderNumberToJSON(value['number']),
        'customerReference': value['customerReference'],
        'createdAt': value['createdAt'].toISOString(),
        'total': value['total'],
        'orderOrigin': OrderOriginToJSON(value['orderOrigin']),
        'orderType': OrderTypeToJSON(value['orderType']),
        'productImageUrls': value['productImageUrls'],
        'shippingAddress': AddressToJSON(value['shippingAddress']),
        'itemSalesAcceptedQuantity': value['itemSalesAcceptedQuantity'],
        'itemCustomerQuantity': value['itemCustomerQuantity'],
    };
}

